import { Form, Input } from "antd";

const CreateUpdateDataTopup = () => {
  const form = Form.useFormInstance();

  return (
    <div className="custom-override">
      <Form.Item
        name="oldPassword"
        rules={[
          {
            required: true,
            message: "Hãy nhập mật khẩu!",
          },
        ]}
      >
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div
            style={{
              width: "50%",
              padding: 5,
              textAlign: "left",
              fontWeight: 500,
            }}
          >
            Mật khẫu cũ
          </div>
          <Input.Password placeholder="Mật khẩu" id="oldPasswords" />
        </div>
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: "Hãy nhập mật khẩu!",
          },
        ]}
      >
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div
            style={{
              width: "50%",
              padding: 5,
              textAlign: "left",
              fontWeight: 500,
            }}
          >
            Mật khẫu mới
          </div>
          <Input.Password placeholder="Mật khẩu mới" id="password" />
        </div>
      </Form.Item>
      <Form.Item
        name="confirmPassword"
        dependencies={["password"]}
        hasFeedback
        rules={[
          {
            required: true,
            message: "Xin mời xác thực mật khẩu !",
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("Mật khẩu xác thực không trùng khớp !"),
              );
            },
          }),
        ]}
      >
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div
            style={{
              width: "50%",
              padding: 5,
              textAlign: "left",
              fontWeight: 500,
            }}
          >
            Xác nhận mật khẩu
          </div>
          <Input.Password
            placeholder="Xác nhận mật khẩu"
            id="confirmpassword"
          />
        </div>
      </Form.Item>
    </div>
  );
};

export default CreateUpdateDataTopup;
